import script from "./QuizResults.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizResults.vue?vue&type=script&setup=true&lang=js"

import "./QuizResults.vue?vue&type=style&index=0&id=1df6b592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df6b592"]])

export default __exports__